// fun words to call the carts
export const nouns = ['Basket', 'Cart', 'List'];
